/**
 * @file OPMEditorCV 组件导出入口，便于在外部项目中直接引用。
 */

import type { FC } from 'react';
import { useSearchParams } from 'react-router-dom';
import App from './components/App';

export interface OPMEditorCVProps {
  initialData?: string; // JSON 字符串格式的初始数据（Plain 格式）
  ontologyId?: string | null;
  onSave?: (plainData: any) => Promise<any> | void; // 保存回调，返回 Plain 格式数据
  isSaving?: boolean; // 是否正在保存
  canEdit?: boolean; // 是否有管理权限（与首页权限管理tab逻辑一致）
}

const OPMEditorCV: FC<OPMEditorCVProps> = ({
  initialData,
  ontologyId,
  onSave,
  isSaving,
  canEdit = true,
}) => {
  const [searchParams] = useSearchParams();
  // 当 URL 中包含 debug 参数时（无论值为何），启用 debug 模式
  const debug = searchParams.has('debug');

  return (
    <App
      debug={debug}
      initialData={initialData}
      ontologyId={ontologyId}
      onSave={onSave}
      isSaving={isSaving}
      canEdit={canEdit}
    />
  );
};

export default OPMEditorCV;
